export default {
    upgradeLine: 'Upgrade Line',
    lineSeriveIsUpdated: 'Line Serive is updated',
    congratulation: 'Congratulation'
}
